export const adminList = "ADMIN_LIST";
export const adminDashboard = "ADMIN_DASHBOARD";